const fillServerErrors = require('../../../common/components/servererrorfiller');
const { LoginResult } = require('./constant');

module.exports = function ($q, loginService, globalHeaderPanelService, breakpointsService, $state, moveFocus, formValidationService, currentUserService, storePickerService, productGroupCarouselService, dynamicContentService, shopperService, $http, $window, settingsService, googleCaptchaService) {
    return {
        restrict: 'E',
        template: require('./login-form-template.html').trim(),
        scope: {
            onClose: '&?'
        },
        link(scope) {
            if (currentUserService.currentUser !== undefined && !currentUserService.currentUser.isGuest) {
                $state.go('shop.myaccount');
                return;
            }

            // we use the login prompt from the service in the template
            scope.loginService = loginService;
            scope.showResetPassword = false;
            scope.loading = false;
            scope.shopper = shopperService;
            scope.$http = $http;
            scope.settingsService = settingsService;
            scope.isSiftEnabled = false;
            scope.showReCaptchaErrorMessage = false;
            scope.reCaptchaError = null;
            scope.settingsService.getSettingValue('Sift', 'EnableSiftPushEvent').then(function (setting) {
                if (setting) {
                    scope.isSiftEnabled = setting;
                }
            });

            const validateEmail = function () {
                if (scope.Email === undefined || scope.Email.trim() === '') {
                    scope.loginForm.Email.$setValidity('required', false);
                    scope.loginForm.Email.$setTouched();
                    return false;
                }
                return true;
            };

            const validatePassword = function () {
                if (scope.Password === undefined || scope.Password.trim() === '') {
                    scope.loginForm.Password.$setValidity('required', false);
                    scope.loginForm.Password.$setTouched();
                    return false;
                }
                return true;
            };
            const validateLoginForm = function () {

                return validateEmail() && validatePassword();
            };

            const setServerErrorValidity = function (isValid) {
                scope.loginForm.Email.$setValidity('loginError', isValid);
                scope.loginForm.Password.$setValidity('loginError', isValid);

                if (!isValid) {
                    formValidationService.focusSummary = true;
                }
            };

            scope.login = function (email, password) {
                fillServerErrors.clearForm(scope.loginForm, scope);
                setServerErrorValidity(true);
                scope.showReCaptchaErrorMessage = false;

                if (!scope.loginForm.$valid || !validateLoginForm()) {
                    // don't submit to server if client side is not valid
                    return $q.reject();
                }
                scope.loading = true;

                return googleCaptchaService
                    .execute(googleCaptchaService.ReCaptchaActions.Login)
                    .then((token) => {
                        const reCaptchaConfig = {
                            token,
                            action: googleCaptchaService.ReCaptchaActions.Login,
                            version: 'v3'
                        };

                        if ($state.is('shop.authentication.login') && $state.previous && $state.previous.route) {
                            // login form -> redirect to previous url after login
                            loginService.setRedirectTo($state.previous.route.name, $state.previous.routeParams);
                        } else if (!$state.is('shop.authentication.login')) {
                            // mobile sidenav -> redirect to this url after login
                            loginService.setRedirectTo($state.current.name, $state.params);
                        }

                        return loginService.login(email, password, reCaptchaConfig)
                            .then(function (response) {
                                if (response.LoginResult === LoginResult.SUCCESS) { //this should check the response when it is implemented.
                                    scope.AuthenticationErrorMessage = null;

                                    if (response.ShouldUpdatePassword) {
                                        $state.go('shop.secureaccount.form');
                                    }
                                } else if (response.LoginResult === LoginResult.REQUIRE_EMAIL_MFA) {
                                    $state.go('shop.authentication.verifyEmail', { email, password, emailMasked: response.MaskedEmail });
                                } else if (response.LoginResult === LoginResult.REQUIRE_PHONE_CAPTURE) {
                                    $state.go('shop.authentication.mobileNumberCapture', { email, password });
                                } else if (response.LoginResult === LoginResult.REQUIRE_SMS_MFA) {
                                    $state.go('shop.authentication.verifyMobile', { email, password, phoneMasked: response.MaskedPhone });
                                } else if (response.LoginResult === LoginResult.TOO_MANY_MFA_ATTEMPTS) {
                                    $state.go('shop.authentication.error', { error: 'TooManyCodeGenerationAttempts' });
                                } else if (response.LoginResult === LoginResult.REDIRECT_PASSWORD_REMAINDER) {
                                    scope.AuthenticationErrorMessage = null;
                                    scope.displayResetPassword();
                                    scope.loading = false;
                                } else if (response.LoginResult === LoginResult.RESET_PASSWORD) {
                                    scope.AuthenticationErrorMessage = null;
                                    $state.go('shop.authentication.resetpassword', { passwordResetToken: response.PasswordResetToken });
                                    if (breakpointsService.isInSmallFormat) {
                                        globalHeaderPanelService.openPanel(globalHeaderPanelService.panels.browse);
                                    } else {
                                        globalHeaderPanelService.closePanel();
                                    }
                                    scope.loading = false;
                                } else {
                                    scope.AuthenticationErrorMessage = loginService.appendAttemptsRemaining(response);
                                    setServerErrorValidity(false);
                                    scope.loading = false;
                                }
                                return response;
                            })
                            .then(function (response) {
                                if (response.LoginResult === 'Success') {
                                    storePickerService.init();
                                    // sift login event
                                    if (scope.isSiftEnabled) {
                                        const userId = scope.shopper ? scope.shopper.Id : '';
                                        scope.$http({
                                            method: 'GET',
                                            url: `${$window.config.apiUrl}/Bootstrap`
                                        }).then((result) => {
                                            const sessionId = JSON.stringify(result.data['/Settings/PageModel'].Context.ContextId);
                                            window._sift.push(['_setUserId', userId]);
                                            window._sift.push(['_setSessionId', sessionId]);
                                            loginService.redirectAfterLogin();
                                        });
                                    }
                                    if (breakpointsService.isInSmallFormat) {
                                        globalHeaderPanelService.openPanel(globalHeaderPanelService.panels.browse);
                                    } else {
                                        globalHeaderPanelService.closePanel();
                                        if ($state.current.name === 'shop.inspiration.win.page') {
                                            return;
                                        } else if ($state.current.name === 'shop.authentication.login' && $state.previous.route.name !== '') {
                                            $state.go($state.previous.route.name, $state.previous.routeParams);
                                        }
                                    }
                                }
                            })
                            .then(function () {
                                productGroupCarouselService.invalidate();
                                dynamicContentService.invalidateCache();
                            })
                            .catch(function (response) {
                                scope.loading = false;
                                fillServerErrors.fillForm(scope.loginForm, response.data.ResponseStatus.Errors, scope);
                                setServerErrorValidity(false);
                            });
                    })
                    .catch((error) => {
                        scope.loading = false;
                        scope.reCaptchaError = error;
                        scope.showReCaptchaErrorMessage = true;
                    });
            };

            scope.goToSignup = function () {
                if (!breakpointsService.isInSmallFormat) {
                    $state.go('shop.authentication.signup');
                    globalHeaderPanelService.closePanel();
                } else if (breakpointsService.isInSmallFormat && globalHeaderPanelService._openPanel === 'none') {
                    $state.go('shop.authentication.signup');
                } else {
                    globalHeaderPanelService.openPanel(globalHeaderPanelService.panels.signup);
                }
            };

            scope.goToForgotPassword = function () {
                if (!breakpointsService.isInSmallFormat) {
                    $state.go('shop.authentication.forgotpassword', { emailAddress: scope.Email });
                    globalHeaderPanelService.closePanel();
                } else if (breakpointsService.isInSmallFormat && globalHeaderPanelService._openPanel === 'none') {
                    $state.go('shop.authentication.forgotpassword', { emailAddress: scope.Email });
                } else {
                    globalHeaderPanelService.openPanel(globalHeaderPanelService.panels.resetpassword);
                }
            };

            scope.closeResetPasswordForSF = function () {
                if (scope.showResetPassword) {
                    scope.showResetPassword = false;
                }
            };

            scope.closeLoginPrompt = function () {
                if (scope.onClose) {

                    if (breakpointsService.isInSmallFormat) {
                        scope.closeResetPasswordForSF();
                    }
                    scope.onClose();
                }
            };

            scope.$on('headerPanel:close', function (event, panelName) {
                if (panelName === globalHeaderPanelService.panels.login) {
                    moveFocus('#loginPanel-toggleButton');
                }
            });
            scope.$on('headerPanel:open', function (event, panelName) {
                if (typeof moveFocus === 'function' && panelName === globalHeaderPanelService.panels.login) {
                    moveFocus('#loginForm-Email');
                }
            });
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/login-form-directive.js
 **/